export const WEIGHT_CHARTS_INJECTION_KEY = Symbol('weightChartsInjectionKey');
